const useStyles = (theme, fullScreem, editMode) => ({
  stackOption: {
    flexDirection: "row",
    width: "100%",
    p: "5px",
    alignItems: "center",
  },
  textoLimitado: {
    display: "-webkit-box",
    WebkitLineClamp: 2, // Limita o texto a 2 linhas
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  textAdorment: {
    ml: "-5px",
    fontSize: "12px",
    fontWeight: 800,
    color: theme.palette.color.bgIcon,
  },
  removeIncDec: {
    "& input[type=number]": {
      MozAppearance: "textfield", // Remove as setas no Firefox
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
  buttonAdd: {
    width: "max-content",
    padding: "2px 10px",
    justifyContent: "flex-start",
    textTransform: "none",
    fontWeight: 400,
    mt: "-4px",
    mb: "-2px",

    color: theme.palette.mode == "dark" ? "#ff8282" : "none",
  },
  buttonBottom: {
    width: "33%",
    textTransform: "none",
  },

  text: {
    fontSize: "0.875rem",
    color: theme.palette.color.text,
  },
  textPaperTitle: {
    fontSize: "18px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "200px",
  },
  paper: {
    borderRadius: "0px",
    height: "100vh",
    position: "sticky",
    width: "340px!important",
    backgroundColor: theme.palette.background.sideBar,
  },
  card: {
    borderRadius: "5px",
    backgroundColor: theme.palette.background.paperSelectedMaps,
    boxShadow: "0px 0px 3px  #0000001a",
    border: "none",
    "&::before": {
      display: "none",
    },
  },

  header: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    gap: 2,
    p: "15px",
  },
  container: {
    height: "auto",
    overflow: "auto",
    paddingRight: "5px",
    gap: 1.5,
    flex: 1,
  },
  tabs: {
    "& button": {
      color: theme.palette.text.disabled,
      textTransform: "none",
      minHeight: "20px",
      Height: "100%",
      borderRadius: "5px",
      paddingX: "10px",
    },
    "& .MuiTab-icon": { marginRight: "2px" },
    "& button.Mui-selected": {
      backgroundColor: theme.palette.background.tab,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      border: "none",
    },
  },
  drawer: {
    position: "absolute",
    clipPath: "none",
    marginTop: "65px",
    flexShrink: 0,
    overflow: "visible",
    "& .MuiDrawer-paper": {
      borderRadius: "7px",
      color: theme.palette.text.primary,
      mr: "10px",
      width: { xs: "90vw", sm: "380px" },
      padding: "10px 10px",

      height: {
        xs: fullScreem ? "calc(100vh - 120px)" : "calc(100vh - 180px)",
        sm: fullScreem ? "calc(100vh - 20px)" : "calc(100vh - 85px)",
      },
      marginTop: {
        xs: fullScreem ? "45px" : "100px",
        sm: fullScreem ? "10px" : "75px",
      },

      overflow: "visible",
      backgroundColor: theme.palette.background.sideBar,
      border: "1px solid " + theme.palette.color.appBarBorder,
      display: "flex",
      gap: 2,
    },
  },
});

export default useStyles;
